<template>
	<div class="wrap">
		<head-info></head-info>
		<div class="main">
			<img src="@/assets/imgs/title.png" />
			<div class="card">
				<p class="text">请记住报名序号，再次登录时必须填写报名序号！</p>
				<p class="user-id">报名序号：{{ serial_id }}</p>
				<template v-if="verify !== 3 && isVerify">
					<div>
						<span>此报名必须上传照片，上传请单击</span>
						<el-button
							type="primary"
							@click="
								() => {
									$router.push('/photo');
								}
							"
						>
							上传照片
						</el-button>
					</div>
					<div>
						<span>报名信息已成功保存，修改请单击</span>
						<el-button type="primary" v-if="verify !== 3 && isVerify" @click="handleEdit()">信息修改</el-button>
						<el-button type="info" disabled v-else>信息修改</el-button>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import HeadInfo from '@/components/HeadInfo';
import { mapState } from 'vuex';
export default {
	components: {
		HeadInfo
	},
	data() {
		return {
		};
	},
	computed: {
		...mapState({
			refresh: state => state.system.refresh,
			serial_id: state => state.user.examinee.serial_id,
			verify_time: state => state.system.examInfo.verify_time,
			verify: state => state.user.examinee.verify,
		}),
		// 是否可以审核
		isVerify() {
			return new Date().getTime() < new Date(this.verify_time.replace(/\s/,'T')).getTime();
		}
	},
	mounted() {
		if(this.serial_id && this.refresh) {
			if(this.$store.state.user.addFormNum !== 1) {
				this.$store.commit('system/SET_REFRESH', 0);
				window.location.href = `${window.location.origin}${window.location.pathname}?${Date.now()}`;
				return;
			} else {
				this.$store.commit('user/SET_ADD_FORM_NUM', 0);
			}
		}
	},
	methods: {
		handleEdit() {
			this.$router.push('/info-maintain');
		}
	}
};
</script>

<style lang="scss" scoped>
.main {
	padding-top: 1px;
	position: relative;
	margin-top: 50px;

	img {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 2;
	}
	.card {
		position: relative;
		width: 400px;
		padding: 40px 20px 20px;
		margin: 20px auto;
		border-radius: 10px;
		background: #ffffff;
		box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.16);
		display: flex;
		flex-direction: column;
		align-items: center;
		&::after {
			position: absolute;
			top: -10px;
			left: 50%;
			content: '温馨提示';
			color: #fff;
			font-size: 16px;
			letter-spacing: 3px;
			z-index: 3;
			transform: translateX(-50%);
		}
		.text {
			font-size: 14px;
			color: #1a222e;
		}
		.user-id {
			font-size: 24px;
			color: #ff070a;
			font-weight: 500;
			margin-top: 15px;
		}
		> div {
			margin-top: 15px;
			display: flex;
			align-items: center;
			span {
				color: #717171;
				margin-right: 10px;
				font-size: 12px;
			}
		}
	}
}
</style>
